export default "__VITE_ASSET__CKHZwDOX__"